// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calculator-form {
  margin-bottom: 15px;
}

.calculator-controls {
  margin-bottom: 15px;
}

.form-card {
  height: 100%;
}

.form-card-body {
  max-height: none;
  overflow-y: visible;
}

.calculate-mode-dropdown {
  font-weight: 500;
}

.results-card {
  height: 100%;
}

.diagram-card {
  margin-bottom: 1rem;
  margin-top: 0;
}

.diagram-row {
  margin-top: 1rem;
}

.circuit-diagram {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}

.circuit-container {
  width: 100%;
  overflow-x: visible;
  overflow-y: visible;
  margin: 0;
  padding: 0;
}

.calculated-field {
  background-color: #f8f9fa;
  font-weight: bold;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

/* SVG specific styles */
.svg-diagram {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  background-color: #fff;
}

.wire {
  stroke-width: 2;
  fill: none;
}

.resistor-zigzag {
  stroke-width: 2;
  fill: none;
}

.resistor-label {
  font-size: 12px;
  font-family: Arial, sans-serif;
  text-anchor: middle;
  fill: #333;
}

.voltage-label {
  font-size: 14px;
  font-family: Arial, sans-serif;
  fill: #000;
}

.voltage-value {
  font-family: Arial, sans-serif;
}

.ground-symbol {
  stroke-width: 2;
}

.title-text {
  font-family: Arial, sans-serif;
  fill: #333;
}

.legend-title {
  font-family: Arial, sans-serif;
  fill: #333;
}

.legend-text {
  font-family: Arial, sans-serif;
  fill: #555;
}

/* Dark mode support */
[data-bs-theme="dark"] .svg-diagram {
  background-color: #000;
}

[data-bs-theme="dark"] .title-text,
[data-bs-theme="dark"] .legend-title {
  fill: #eee;
}

[data-bs-theme="dark"] .legend-text,
[data-bs-theme="dark"] .resistor-label {
  fill: #ddd;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-card-body {
    max-height: none;
    overflow-y: visible;
  }
  
  .circuit-container {
    margin: 0;
    padding: 0;
  }
  
  .circuit-diagram {
    position: static;
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    padding-bottom: 0;
  }
  
  .svg-diagram {
    position: static;
    width: 100%;
    height: auto;
  }
  
  .diagram-card {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  
  .description-card {
    margin-bottom: 0.5rem; 
  }

  .description-card .card-body,
  .diagram-card .card-body {
    padding: 0.5rem;
  }

  .diagram-card .card-header {
    padding: 0.5rem;
    margin-bottom: 0;
    font-size: 1rem;
  }

  h1.mb-md-4.mb-1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem !important;
  }

  .container.mobile-container {
    padding: 0.5rem;
  }
}

/* SVG Text Styling */
.svg-text {
  font-family: 'Inter', Arial, sans-serif;
  font-size: 12px;
  letter-spacing: 0em;
}

.svg-text-not-rgb-modifiable {
  font-size: 64px;
  font-weight: bold;
}

.svg-text-heading {
  font-size: 32px;
  font-weight: bold;
}

.svg-text-title {
  font-size: 24px;
  font-weight: bold;
}

.svg-text-subtitle {
  font-size: 20px;
}

.svg-text-xlarge {
  font-size: 20px;
  font-weight: normal;
}

.svg-text-large {
  font-size: 18px;
  font-weight: normal;
}

.svg-text-medium {
  font-size: 16px;
  font-weight: normal;
}

.svg-text-normal {
  font-size: 14px;
  font-weight: normal;
}

.svg-text-small {
  font-size: 12px;
  font-weight: normal;
}

.svg-text-xsmall {
  font-size: 10px;
  font-weight: normal;
}

.svg-text-bold {
  font-weight: bold;
}

.svg-diagram {
  font-size: 18px;
  font-weight: normal;
}

.svg-text-center {
  text-anchor: middle;
}

.description-card {
  margin-bottom: 0.5rem;
}

.voltage-calc-card {
  border-left: 4px solid #007bff;
}

.voltage-calc-card .card-body {
  padding: 0.75rem;
}

.voltage-calc-card h6 {
  color: #007bff;
  margin-bottom: 0.5rem;
}

.highlighted-calc-field {
  border: 3px solid #ffc107 !important;  /* Bootstrap warning yellow */
  background-color: rgba(255, 193, 7, 0.05) !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
  font-weight: 500 !important;
  color: #ffc107 !important;
}

.formula-explanation-card {
  border-left: 4px solid #ffc107;
}

.formula-explanation-card .card-body {
  padding: 0.75rem;
}

.formula-explanation-card h6 {
  color: #6c757d;
  margin-bottom: 0.5rem;
}

/* Add styles to discourage password managers */
.non-login-field-wrapper {
  pointer-events: auto !important;
}

.non-login-field-wrapper input {
  background-color: rgba(255, 255, 255, 0.95) !important;
  caret-color: #333 !important;
  /* Prevent Bitwarden icon positioning */
  background-position: calc(100% - 40px) 50% !important;
}

/* Override any external styling that might be added by password managers */
input#crt_model_non_login:-webkit-autofill,
input#crt_model_non_login:-webkit-autofill:hover,
input#crt_model_non_login:-webkit-autofill:focus {
  -webkit-transition: background-color 5000s ease-in-out 0s !important;
  transition: background-color 5000s ease-in-out 0s !important;
  -webkit-text-fill-color: #333 !important;
  box-shadow: 0 0 0px 1000px white inset !important;
}

/* Additional container styling */
.non-login-field-wrapper::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
} 

/* Mod Boards Styling */
.mod-boards-section {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.mod-board-purchase-link {
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  text-decoration: none;
  border-radius: 0.375rem;
  display: inline-flex;
  align-items: center;
}

.mod-board-purchase-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.mod-board-purchase-link:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);
}

/* Responsive adjustments for mod boards */
@media (max-width: 576px) {
  .mod-boards-section {
    flex-direction: column;
    align-items: stretch;
  }
  
  .mod-board-purchase-link {
    width: 100%;
    justify-content: center;
    margin-bottom: 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/RGBMuxCalculator.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,uCAAuC;EACvC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC,GAAG,6BAA6B;EACpE,oDAAoD;EACpD,gDAAgD;EAChD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,+BAA+B;AACjC;;AAEA;EACE,sDAAsD;EACtD,4BAA4B;EAC5B,uCAAuC;EACvC,qDAAqD;AACvD;;AAEA,2EAA2E;AAC3E;;;EAGE,oEAA4D;EAA5D,4DAA4D;EAC5D,wCAAwC;EACxC,iDAAiD;AACnD;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA,0CAA0C;AAC1C;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".calculator-form {\n  margin-bottom: 15px;\n}\n\n.calculator-controls {\n  margin-bottom: 15px;\n}\n\n.form-card {\n  height: 100%;\n}\n\n.form-card-body {\n  max-height: none;\n  overflow-y: visible;\n}\n\n.calculate-mode-dropdown {\n  font-weight: 500;\n}\n\n.results-card {\n  height: 100%;\n}\n\n.diagram-card {\n  margin-bottom: 1rem;\n  margin-top: 0;\n}\n\n.diagram-row {\n  margin-top: 1rem;\n}\n\n.circuit-diagram {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.circuit-container {\n  width: 100%;\n  overflow-x: visible;\n  overflow-y: visible;\n  margin: 0;\n  padding: 0;\n}\n\n.calculated-field {\n  background-color: #f8f9fa;\n  font-weight: bold;\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n/* SVG specific styles */\n.svg-diagram {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-width: 100%;\n  background-color: #fff;\n}\n\n.wire {\n  stroke-width: 2;\n  fill: none;\n}\n\n.resistor-zigzag {\n  stroke-width: 2;\n  fill: none;\n}\n\n.resistor-label {\n  font-size: 12px;\n  font-family: Arial, sans-serif;\n  text-anchor: middle;\n  fill: #333;\n}\n\n.voltage-label {\n  font-size: 14px;\n  font-family: Arial, sans-serif;\n  fill: #000;\n}\n\n.voltage-value {\n  font-family: Arial, sans-serif;\n}\n\n.ground-symbol {\n  stroke-width: 2;\n}\n\n.title-text {\n  font-family: Arial, sans-serif;\n  fill: #333;\n}\n\n.legend-title {\n  font-family: Arial, sans-serif;\n  fill: #333;\n}\n\n.legend-text {\n  font-family: Arial, sans-serif;\n  fill: #555;\n}\n\n/* Dark mode support */\n[data-bs-theme=\"dark\"] .svg-diagram {\n  background-color: #000;\n}\n\n[data-bs-theme=\"dark\"] .title-text,\n[data-bs-theme=\"dark\"] .legend-title {\n  fill: #eee;\n}\n\n[data-bs-theme=\"dark\"] .legend-text,\n[data-bs-theme=\"dark\"] .resistor-label {\n  fill: #ddd;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .form-card-body {\n    max-height: none;\n    overflow-y: visible;\n  }\n  \n  .circuit-container {\n    margin: 0;\n    padding: 0;\n  }\n  \n  .circuit-diagram {\n    position: static;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n    padding-bottom: 0;\n  }\n  \n  .svg-diagram {\n    position: static;\n    width: 100%;\n    height: auto;\n  }\n  \n  .diagram-card {\n    margin-top: 0;\n    margin-bottom: 1rem;\n  }\n  \n  .description-card {\n    margin-bottom: 0.5rem; \n  }\n\n  .description-card .card-body,\n  .diagram-card .card-body {\n    padding: 0.5rem;\n  }\n\n  .diagram-card .card-header {\n    padding: 0.5rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n  }\n\n  h1.mb-md-4.mb-1 {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .container.mobile-container {\n    padding: 0.5rem;\n  }\n}\n\n/* SVG Text Styling */\n.svg-text {\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 12px;\n  letter-spacing: 0em;\n}\n\n.svg-text-not-rgb-modifiable {\n  font-size: 64px;\n  font-weight: bold;\n}\n\n.svg-text-heading {\n  font-size: 32px;\n  font-weight: bold;\n}\n\n.svg-text-title {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.svg-text-subtitle {\n  font-size: 20px;\n}\n\n.svg-text-xlarge {\n  font-size: 20px;\n  font-weight: normal;\n}\n\n.svg-text-large {\n  font-size: 18px;\n  font-weight: normal;\n}\n\n.svg-text-medium {\n  font-size: 16px;\n  font-weight: normal;\n}\n\n.svg-text-normal {\n  font-size: 14px;\n  font-weight: normal;\n}\n\n.svg-text-small {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.svg-text-xsmall {\n  font-size: 10px;\n  font-weight: normal;\n}\n\n.svg-text-bold {\n  font-weight: bold;\n}\n\n.svg-diagram {\n  font-size: 18px;\n  font-weight: normal;\n}\n\n.svg-text-center {\n  text-anchor: middle;\n}\n\n.description-card {\n  margin-bottom: 0.5rem;\n}\n\n.voltage-calc-card {\n  border-left: 4px solid #007bff;\n}\n\n.voltage-calc-card .card-body {\n  padding: 0.75rem;\n}\n\n.voltage-calc-card h6 {\n  color: #007bff;\n  margin-bottom: 0.5rem;\n}\n\n.highlighted-calc-field {\n  border: 3px solid #ffc107 !important;  /* Bootstrap warning yellow */\n  background-color: rgba(255, 193, 7, 0.05) !important;\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);\n  font-weight: 500 !important;\n  color: #ffc107 !important;\n}\n\n.formula-explanation-card {\n  border-left: 4px solid #ffc107;\n}\n\n.formula-explanation-card .card-body {\n  padding: 0.75rem;\n}\n\n.formula-explanation-card h6 {\n  color: #6c757d;\n  margin-bottom: 0.5rem;\n}\n\n/* Add styles to discourage password managers */\n.non-login-field-wrapper {\n  pointer-events: auto !important;\n}\n\n.non-login-field-wrapper input {\n  background-color: rgba(255, 255, 255, 0.95) !important;\n  caret-color: #333 !important;\n  /* Prevent Bitwarden icon positioning */\n  background-position: calc(100% - 40px) 50% !important;\n}\n\n/* Override any external styling that might be added by password managers */\ninput#crt_model_non_login:-webkit-autofill,\ninput#crt_model_non_login:-webkit-autofill:hover,\ninput#crt_model_non_login:-webkit-autofill:focus {\n  transition: background-color 5000s ease-in-out 0s !important;\n  -webkit-text-fill-color: #333 !important;\n  box-shadow: 0 0 0px 1000px white inset !important;\n}\n\n/* Additional container styling */\n.non-login-field-wrapper::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n} \n\n/* Mod Boards Styling */\n.mod-boards-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.mod-board-purchase-link {\n  transition: all 0.2s ease-in-out;\n  font-weight: 500;\n  text-decoration: none;\n  border-radius: 0.375rem;\n  display: inline-flex;\n  align-items: center;\n}\n\n.mod-board-purchase-link:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n}\n\n.mod-board-purchase-link:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);\n}\n\n/* Responsive adjustments for mod boards */\n@media (max-width: 576px) {\n  .mod-boards-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .mod-board-purchase-link {\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 0.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
